import type { SelectOption } from './types';

export const MONITORING_INTERVALS: SelectOption[] = [
    { value: '15', label: 'Каждые 15 сек' },
    { value: '30', label: 'Каждые 30 сек' },
    { value: '60', label: 'Каждую минуту' },
    { value: '300', label: 'Каждые 5 мин' },
];

export const AUTO_LOGOUT_OPTIONS: SelectOption[] = [
    { value: '15', label: '15 минут' },
    { value: '30', label: '30 минут' },
    { value: '60', label: '1 час' },
    { value: '1440', label: '24 часа' },
    { value: '0', label: 'Никогда' },
];

export const LANGUAGES: SelectOption[] = [
    { value: 'ru', label: 'Русский' },
    { value: 'en', label: 'English' },
];

export const TIMEZONES: SelectOption[] = [
    { value: 'Europe/Moscow', label: 'Москва (UTC+3)' },
    { value: 'Europe/London', label: 'Уфа (UTC+5)' },
];

export const DEFAULT_SETTINGS = {
    monitoringInterval: 30,
    slowLoadThreshold: 800,
    darkMode: false,
    animations: true,
    pushNotifications: true,
    emailNotifications: false,
    soundAlerts: true,
    language: 'ru',
    timezone: 'Europe/Moscow',
    autoLogout: 30,
    twoFactor: false,
    sessionTimeout: 30,
};

export const SETTINGS_STORAGE_KEY = 'scanta-settings-v1';